export default __webpack_public_path__ + "static/media/Tour.205864f0.PNG";